module.exports = __webpack_public_path__ + "img/game_main_pc_247_off.add62eee.png";